import { FC } from 'react';

export const ViewComfy: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 1V6C0 6.55 0.45 7 1 7H19C19.55 7 20 6.55 20 6V1C20 0.45 19.55 0 19 0H1C0.45 0 0 0.45 0 1ZM9 16H19C19.55 16 20 15.55 20 15V10C20 9.45 19.55 9 19 9H9C8.45 9 8 9.45 8 10V15C8 15.55 8.45 16 9 16ZM1 16H5C5.55 16 6 15.55 6 15V10C6 9.45 5.55 9 5 9H1C0.45 9 0 9.45 0 10V15C0 15.55 0.45 16 1 16Z" />
    </svg>
  );
};
